import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { useDebounce } from "use-debounce";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { getServicesRequest } from "../../store/services/actions";
import { ServiceTable } from "./ServiceTable";

const ServiceList = () => {
  document.title = "Serviços | Ecoguias - Admin Dashboard";
  const history = useHistory();
  const dispatch = useDispatch();

  const { loading, data } = useSelector((state) => state.Services);

  const [searchInput, setSearchInput] = useState("");
  const [value] = useDebounce(searchInput, 500);

  useEffect(() => {
    dispatch(getServicesRequest(value));
  }, [dispatch, value]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Tabela de serviços" pageTitle="Serviços" />
          <div className="d-flex justify-content-between pb-4 flex-wrap">
            <Input
              type="text"
              style={{ maxWidth: 250 }}
              className="form-control"
              placeholder="Pesquisar..."
              id="search-options"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button
              className="btn btn-primary"
              onClick={() => history.push("/services-form")}
            >
              Cadastrar
            </button>
          </div>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Serviços</h5>
                </CardHeader>
                <CardBody>
                  <ServiceTable
                    style={{ width: "100%" }}
                    services={data?.result}
                    loading={loading}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ServiceList;
